// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__JRW84","toggleSlider":"Toggle_toggleSlider__xtssn","toggleText":"Toggle_toggleText__3N6sd"};